import React, { useState } from "react";
const Whistleblowing = ({ contenuti, isMobile }) => {
  const [aperto, setAperto] = useState(null);
  const [accettati, setAccettati] = useState({});
  const informativa = "La piattaforma Whistleblowing è uno dei canali di comunicazione che permette a dipendenti, collaboratori, consulenti, fornitori dell'organizzazione e ogni altro soggetto terzo che abbia una relazione con la società di inviare, anche in forma anonima, segnalazioni relative a condotte negligenti, illecite, irregolari o non corrette, delle quali si è venuti a conoscenza nello svolgimento delle proprie funzioni e/o nello svolgimento dell'attività lavorativa, integranti violazioni di normative nazionali o dell'Unione europea che ledono l'interesse pubblico o l'integrità aziendale, poste in essere da soggetti che, a qualsiasi titolo, collaborano o hanno rapporti con la Società (dipendenti, partner commerciali e terzi in genere).";
  const items = Object.values(contenuti || {}).sort((a, b) => Number(a.ordine) - Number(b.ordine));
  const onApri = (id) => {
    setAperto((prev) => prev === id ? null : id);
    setAccettati((prev) => ({
      ...prev,
      [id]: false
    }));
  };
  const onAccetta = (id, checked) => {
    setAccettati((prev) => ({
      ...prev,
      [id]: checked
    }));
  };
  return (
    <div style={{marginBottom:'5rem'}} className="container mt-5">
        <div className="row g-4">
      {items.map((item) => (
        <div className="col-12" key={item.ID}>
          <div className="row align-items-center g-3 pb-4 border-bottom">
            <div className="col-12 col-md">
              <h3 className="mb-1">
                {item.titolo_it}
              </h3>
              {item.sottotitolo_it && (
                <p className="mb-0">
                  {item.sottotitolo_it}
                </p>
              )}
            </div>
            <div className="col-12 col-md-auto">
              <button
                type="button"
                className={`btn btn-sm btn-three ${isMobile ? "w-100" : ""}`}
                onClick={() => onApri(item.ID)}
              >
                {aperto === item.ID ? "Chiudi" : item.call_to_action_it || "Invia Segnalazione"}
              </button>
            </div>
            {aperto === item.ID && (
              <div className="col-12">
                <div className="mt-2">
                  <p className="mb-3">
                    {informativa}
                  </p>
                  <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      id={`whistleblowing-${item.ID}`}
                      className="form-check-input"
                      checked={accettati[item.ID] || false}
                      onChange={(e) => onAccetta(item.ID, e.target.checked)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`whistleblowing-${item.ID}`}
                    >
                      Ho letto e accettato l'informativa
                    </label>
                  </div>
                  {accettati[item.ID] && (
                    <div className={`d-flex ${isMobile ? "justify-content-stretch" : "justify-content-start"}`}>
                      <a
                        href={item.link_it}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`btn btn-sm btn-three ${isMobile ? "w-100" : ""}`}
                      >
                        {item.call_to_action_it || "Invia Segnalazione"}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};
export default Whistleblowing;